module.exports = __webpack_public_path__ + "img/lowcode-2-2.19c48f6e.svg";